import React, {createContext, useContext} from 'react'
import {UserReportReasonEnum} from '@colonist/game-base-types'
import {PlayerColor} from '@colonist/game-states'

interface UIGameSocketContextProps {
    sendReportPlayer: (reportReason: UserReportReasonEnum, color: PlayerColor) => void
    sendToggleEmbargoAgainstPlayer: (color: PlayerColor) => void
}

const UIGameSocketContext = createContext<UIGameSocketContextProps | undefined>(undefined)

export const useUIGameSocketContext = () => {
    const context = useContext(UIGameSocketContext)
    if(context === undefined) {
        throw new Error('useUIGameSocketContext must be used within a UIGameSocketProvider')
    }
    return context
}

interface UIGameSocketProviderProps {
    sendReportPlayer: (reportReason: UserReportReasonEnum, color: PlayerColor) => void
    sendToggleEmbargoAgainstPlayer: (color: PlayerColor) => void
    children: React.ReactNode
}

export const UIGameSocketProvider = ({
    sendReportPlayer,
    sendToggleEmbargoAgainstPlayer,
    children,
}: UIGameSocketProviderProps) => <UIGameSocketContext.Provider value={{
    sendReportPlayer: sendReportPlayer,
    sendToggleEmbargoAgainstPlayer: sendToggleEmbargoAgainstPlayer,
}}>
    {children}
</UIGameSocketContext.Provider>
